import "./service_dashboard.css"

import Graphic5 from "../../../../assets/Images/Elements/Arrow_B1.svg"
import Graphic6 from "../../../../assets/Images/Elements/Arrow_W1.svg"

export default function ServuceDashboardComponent() {
    return (
        <div>
            <div className="ServiceDashboardComponent-Main-Flex">
                <div className="ServiceDashboardComponent-Sub-Flex">
                    <a className="ServiceDashboardComponent-Sub-Flex-Cards" href="/services/website-design-and-development">
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Heading">
                            <h3>Website Design & Development</h3>
                            <img src={Graphic5}/>
                        </div>
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Info">
                            <span className="KeyTags">WordPress</span>
                            <span className="KeyTags">Shopify </span>
                            <span className="KeyTags">Responsive design</span>
                            <span className="KeyTags">UX design</span>
                            <span className="KeyTags">scalable</span>
                        </div>
                    </a>
                    <a className="ServiceDashboardComponent-Sub-Flex-Cards" href="/services/analytics-and-performance-reporting">
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Heading">
                            <h3>Analytics & Performance Reporting</h3>
                            <img src={Graphic5}/>
                        </div>
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Info">
                            <span className="KeyTags">data insights</span>
                            <span className="KeyTags">digital analytics</span>
                            <span className="KeyTags">performance reporting</span>
                            <span className="KeyTags">website analytics</span>
                            <span className="KeyTags">growth insights</span>
                        </div>
                    </a>
                    <a className="ServiceDashboardComponent-Sub-Flex-Cards" href="/services/search-engine-optimization">
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Heading">
                            <h3>Search Engine Optimization (SEO)</h3>
                            <img src={Graphic5}/>
                        </div>
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Info">
                            <span className="KeyTags">organic traffic</span>
                            <span className="KeyTags">local SEO</span>
                            <span className="KeyTags">content optimization</span>
                            <span className="KeyTags">keyword research</span>
                            <span className="KeyTags">website SEO</span>
                        </div>
                    </a>
                </div>
                <div className="ServiceDashboardComponent-Sub-Flex">
                    <a className="ServiceDashboardComponent-Sub-Flex-Cards" href="/services/digital-marketing-strategy">
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Heading">
                            <h3>Digital Marketing Strategy</h3>
                            <img src={Graphic6}/>
                        </div>
                    </a>
                    <a className="ServiceDashboardComponent-Sub-Flex-Cards" href="/services/paid-advertising">
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Heading">
                            <h3>Paid Advertising</h3>
                            <img src={Graphic6}/>
                        </div>
                        <div className="ServiceDashboardComponent-Sub-Flex-Cards-Info">
                            <p>
                                Drive measurable ROI with performance-focused ad campaigns on Google and Meta platforms, optimized for conversions.
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}